/** 购买方式 */
export const BuyType = {
  /** 直接购买 */
  Inner: 'inner',
  /** 外链购买 */
  Link: 'link'
};
